// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"57df6404","453":"73b1f5cf","455":"e020ab9f","977":"b1955c20"}[chunkId] + ".chunk.js";
};